import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useMemo } from 'react';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import {
  getWhyBuyNarrativesAnalytics,
  hasWhyBuyStockImagery
} from '~/utilities/vdp/whyBuyAnalytics';
import useGetWhyBuyDataLoaded from './selectors/useGetWhyBuyDataLoaded';
import useWhyBuyData from './selectors/useWhyBuyData';
import useWhyBuyNarratives from './selectors/useWhyBuyNarratives';
import useGetVaultWhyBuyNarrative from './useGetVaultWhyBuyNarrative';
import useShowWhyBuyContent from './useShowWhyBuyContent';

export default function useWhyBuyDataEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { isLoaded: hasWhyBuyLoaded } = useGetWhyBuyDataLoaded();
  const { type: whyBuyType, bulletPoints = [] } = useWhyBuyData();
  const showWhyBuyContent = useShowWhyBuyContent();
  const { narrativeVersion } = useGetVaultWhyBuyNarrative();
  const { narratives: vehicleNarratives } = useGetVehicleDetails();
  const whyBuyNarratives = useWhyBuyNarratives();

  const hasStockImagery = hasWhyBuyStockImagery(bulletPoints);
  const narratives = useMemo(
    () => getWhyBuyNarrativesAnalytics(whyBuyNarratives),
    [whyBuyNarratives]
  );

  useEffectOnce(
    () => {
      const eventData = {
        availableWhyBuyNarratives:
          vehicleNarratives?.map(n => ({
            narrativeType: n?.narrativeType,
            narrativeVersion: n?.narrativeVersion
          })) ?? [],
        hasStockImagery,
        hasWhyBuy: showWhyBuyContent,
        narratives,
        narrativeVersion: narrativeVersion ?? 'ymmt',
        whyBuyCount: bulletPoints?.length ?? 0,
        whyBuyType
      };

      trackEvent('Why Buy Data', eventData);
      datadogRum.addAction('Why Buy Data', eventData);
    },
    [
      bulletPoints?.length,
      hasStockImagery,
      narratives,
      narrativeVersion,
      showWhyBuyContent,
      trackEvent,
      vehicleNarratives,
      whyBuyType
    ],
    hasWhyBuyLoaded
  );
}
